<template>
  <div class="tl-container">
    <nav-menu :id="id" :active-index="3"></nav-menu>
    <common-panel style="flex: 1;">
      <div class="expect-container">
        <div class="grid-container">
          <div class="row">
            <div class="left">视频信号未接入，敬请期待</div>
            <div class="middle"></div>
            <div class="right">视频信号未接入，敬请期待</div>
          </div>
          <div class="row">
            <div class="left">视频信号未接入，敬请期待</div>
            <div class="middle"></div>
            <div class="right">视频信号未接入，敬请期待</div>
          </div>
        </div>
      </div>
    </common-panel>
  </div>
</template>

<script>
import CommonPanel from '@/components/CommonPanel.vue';
import NavMenu from '@/components/NavMenu.vue';

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  components: {
    CommonPanel,
    NavMenu,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/theme/app.scss';
  .expect-container {
    color: #5D8DF9;
    font-size: 16px;
    height: 100%;
    text-align: center;
  }
  .grid-container {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .row {
    padding: 2rem;
    display: flex;
    flex: 1;
  }
  .left {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    border: 1px solid #3388FD;
  }
  .middle {
    width: 4rem;
  }
  .right{
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    border: 1px solid #3388FD;
  }

</style>
